angular.module('qkr').directive('taxList', ['appConfig', function(appConfig) {
    return {
        restrict: 'E',
        scope: {
            taxConfig: '='
        },
        template: require('../../tax/directives/taxList.html'),
        replace: false,

        link(scope, element, attrs) {
            if (appConfig.outletLevel) {
            	scope.showName = (scope.taxConfig.salesTax.discriminatedValue !== 'POSTALCODE');
                scope.showDiscriminatedValue = (scope.showName && scope.taxConfig.salesTax.discriminatedValue !== 'Default');
            } else {
            	scope.showName = true;
            	scope.showPostalcodeMsg = (scope.taxConfig.applicableTaxRates && scope.taxConfig.applicableTaxRates.length > 0 && scope.taxConfig.applicableTaxRates[0].discriminatedValue === 'POSTALCODE');
            	scope.showDiscriminatedValue = (scope.taxConfig.applicableTaxRates && scope.taxConfig.applicableTaxRates.length > 0 && scope.taxConfig.applicableTaxRates[0].discriminatedValue !== 'Default');
            }
            
            const setUpTaxRates = function() {
                if (scope.taxConfig.outletLevel) {
                    if (scope.taxConfig.isNewProduct) {
                        setDefaultTaxRatesForOutlet(scope.taxConfig.salesTax);
                    } else {
                        setSelectedTaxRatesForOutlet();
                    }
                } else if (scope.taxConfig.isNewProduct) {
                        setDefaultTaxRatesForMerchant();
                    } else {
                        setSelectedTaxRatesForMerchant();
                    }
            };

            var setSelectedTaxRatesForMerchant = function() {
                angular.forEach(scope.taxConfig.applicableTaxRates, (applicableTaxGroup) => {
                    let found = false;
                    let applicableTaxRate;
                    let i;
                    let j;

                    for (i = 0; i < scope.taxConfig.explicitTaxRates.length; i++) {
                        const explicitTaxRate = scope.taxConfig.explicitTaxRates[i];

                        if (explicitTaxRate.discriminator === applicableTaxGroup.discriminatedValue) {
                            for (j = 0; j < applicableTaxGroup.taxRates.length; j++) {
                                applicableTaxRate = applicableTaxGroup.taxRates[j];

                                if (explicitTaxRate.salesTax.id === applicableTaxRate.id) {
                                    applicableTaxGroup.selectedTaxRate = applicableTaxRate;
                                    found = true;
                                    break;
                                }
                            }
                        }
                    }

                    if (!found) {
                        for (i = 0; i < applicableTaxGroup.taxRates.length; i++) {
                            applicableTaxRate = applicableTaxGroup.taxRates[i];

                            if (applicableTaxRate.theDefault) {
                                applicableTaxGroup.selectedTaxRate = applicableTaxRate;
                            }
                        }
                    }
                });
            };

            var setDefaultTaxRatesForMerchant = function() {
                angular.forEach(scope.taxConfig.applicableTaxRates, (taxGroup) => {
                    for (let i = 0; i < taxGroup.taxRates.length; i++) {
                        const defaultTaxRate = taxGroup.taxRates[i];
                        if (defaultTaxRate.theDefault) {
                            taxGroup.selectedTaxRate = defaultTaxRate;
                            break;
                        }
                    }
                });
            };

            var setSelectedTaxRatesForOutlet = function() {
                angular.forEach(scope.taxConfig.salesTax.taxRates, (taxRate) => {
                    if (taxRate.id === scope.taxConfig.explicitTaxRates.id) {
                        scope.taxConfig.currentProduct.salesTax = taxRate;
                    }
                });
            };

            var setDefaultTaxRatesForOutlet = function(salesTax) {
                angular.forEach(salesTax.taxRates, (taxRate) => {
                    if (taxRate.theDefault) {
                        scope.taxConfig.currentProduct.salesTax = taxRate;
                    }
                });
            };
            scope.checkTaxRateChange = function(taxRate) {
                scope.taxConfig.taxConfigurationChanges = true;

                // If at merchant level there will be multiple rates & we need to build an object out of the selected one,
                // Otherwise at outlet level the selected taxrate will just be an id which we store on the product
                if (taxRate.selectedTaxRate) {
                    let foundAlreadyUpdated = false;

                    angular.forEach(scope.taxConfig.updatedSalesTaxList, (salesTax) => {
                        if (salesTax.discriminatedValue === taxRate.discriminatedValue) {
                            salesTax.taxRate = {id: taxRate.selectedTaxRate.id};
                            foundAlreadyUpdated = true;
                        }
                    });

                    if (!foundAlreadyUpdated) {
                        const updatedTaxRate = {};
                        updatedTaxRate.countryIsoCode = taxRate.countryIsoCode;
                        updatedTaxRate.discriminatedValue = taxRate.discriminatedValue;
                        updatedTaxRate.taxRate = {id: taxRate.selectedTaxRate.id};

                        scope.taxConfig.updatedSalesTaxList.push(updatedTaxRate);
                    }
                }
            };

            setUpTaxRates();
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/tax/directives/taxList.js